import { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./App.css";
import Templates from "./component/template";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  const Imgnamelist = [
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp23.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp8.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp9.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp10.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp22.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp7.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp20.jpg",
      content: "Template 3 Content",
    },

    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp4.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp5.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp6.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp11.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp12.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp13.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp14.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp15.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp16.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp17.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp18.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp19.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp21.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp2.jpg",
      content: "Template 2 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp3.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp24.jpg",
      content: "Template 3 Content",
    },
    {
      imgName:
        "https://webapi.entab.info/api/image/ENTAB/public/Images/temp25.jpg",
      content: "Template 3 Content",
    },
  ];

  const [popUp, setPopUp] = useState(null);
  const showPopup = (id) => {
    document.body.classList.add("no-scroll");
    setPopUp(id); // Save the template ID
  };

  const closePopup = () => {
    setPopUp(null);
    document.body.classList.remove("no-scroll");
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const [colorTheme, colorThemeSelected] = useState("1");

  const colorThemeSelect = (value) => {
    colorThemeSelected(value);
  };
  const imgContainerRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const openFullscreen = () => {
    const elem = imgContainerRef.current;
    if (elem) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    }
  };
  useEffect(() => {
    const handleFullscreenChange = () => {
      const isFull =
        document.fullscreenElement === imgContainerRef.current ||
        document.webkitFullscreenElement === imgContainerRef.current ||
        document.msFullscreenElement === imgContainerRef.current;

      setIsFullscreen(isFull);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, []);
  return (
    <div className="App">
      <div className="main-page">
        <img
          src="https://webapi.entab.info/api/image/ENTAB/public/Images/logo.png"
          className="img-fluid"
          alt="Entab"
        />
      </div>
      <h1 className="text-center">Choose Templates</h1>
      <h1 className="blue half-line">
        That suits best for <span>you</span>
      </h1>
      <div className="container-fluid mt-4">
        <div className="row">
          {Imgnamelist.map(({ imgName }, index) => (
            <Templates
              key={index}
              id={index}
              imgName={imgName}
              showPopUp={showPopup} // Pass function correctly
            />
          ))}
        </div>
      </div>
      {popUp === 0 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp23.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp23-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp23-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp23-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp23-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp23-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: TAFFS</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: The Airforce School, Subroto
                    Park
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(19 84 138), rgb(253 174 53))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(72 104 183), rgb(224 255 162))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(148 35 35), rgb(237 164 38))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages. (Optional)
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets(Optional) </li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://www.tafssp.com"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {popUp === 1 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp8.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp8-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp8-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp8-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp8-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp8-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: LCSDD</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: Loreto Convent School, Delhi
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(254 204 81), rgb(116 66 198))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(109 62 187), rgb(252 177 49))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(37 119 193), rgb(255, 166, 0))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links (Optional)</li>
                        <li>Social Media widgets (Optional)</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://www.loretodelhi.com"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {popUp === 2 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp9.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp9-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp9-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp9-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp9-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp9-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: MGMMB</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: MAR GREGORIOS MEMORIAL,
                    Bokaro
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(47 51 78), rgb(164 24 25))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(79 50 80), rgb(223 146 63))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(47 82 114), rgb(71 168 101))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages. (Optional)
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links (Optional)</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://www.mgmhssbokaro.in"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 3 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp10.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp10-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp10-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp10-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp10-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp10-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: MDSND</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: Mater Dei School, New Delhi
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(66, 15, 120), rgb(253 184 1))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(238 129 255), rgb(5 65 91))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(120 255 135), rgb(66 15 120))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages. (Optional)
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                {/* <button
                  className={`preview-button`}
                >
                  <a href="https://www.materdeischool.in/" target="_blank" rel="noreferrer">
                    Live Preview
                  </a>
                </button> */}
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 4 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp22.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp22-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp22-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp22-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp22-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp22-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: TPSPS</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: Tagore Public School, Palwal
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(177 69 145), rgb(100 194 243))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(252 157 78), rgb(122 85 170))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(46 74 135), rgb(88 221 154))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender (Optional) </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links (Optional)</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://tagore.edu.in"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {popUp === 5 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp7.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp7-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp7-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp7-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp7-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp7-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: JRSPPSK</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: Jai Rani Sabs Public School,
                    Kerala
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(238 133 5), rgb(16 59 99))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(204 251 136), rgb(35 50 85))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(131 195 210), rgb(134 23 23))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender (Optional)</li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets (Optional)</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://www.jairanisabspublicschool.in/"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {popUp === 6 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp20.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp20-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp20-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp20-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp20-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp20-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: SPCSFB</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: St. Peter's Convent School
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(163 193 255), rgb(235 220 187))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(186 171 254), rgb(251 197 97))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(163 193 255), rgb(99 50 122))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://www.spcsfbd.ac.in"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 7 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp4.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp4-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp4-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp4-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp4-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp4-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: CCSD</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: Carmel Convent School
                    Dharuhera
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(1 91 40), rgb(252 252 123))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(18 53 117), rgb(239 173 132))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(63 7 10), rgb(241 202 127))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class (Optional)</li>
                        <li>Toppers Of XIIth Class (Optional)</li>
                        <li>Message of Management</li>
                        <li>Academic Calender (Optional)</li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://carmelconventschooldharuhera.com"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 8 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp5.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp5-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp5-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp5-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp5-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp5-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: FSOOLG</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: Franciscan Sisters of Our
                    Lady of Graces
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(119 32 140), rgb(97 13 118))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(144 31 1), rgb(206 62 25))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(39 5 47), rgb(93 13 114))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class (Optional)</li>
                        <li>Toppers Of XIIth Class (Optional)</li>
                        <li>Message of Management</li>
                        <li>Academic Calender (Optional) </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a href="https://fslg.in" target="_blank" rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 9 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp6.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp6-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp6-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp6-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp6-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp6-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: HCSN</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: Holy Cross School, Nautanwa
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(9 64 94), rgb(224 187 44))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(25 49 95), rgb(182 43 19))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(240 175 37), rgb(22 88 162))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://www.holycrossschoolnautanwa.in"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {popUp === 10 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp11.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp11-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp11-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp11-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp11-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp11-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: ABCD</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: Mercy Memorial School, Kanpur
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(43 93 204), rgb(254 150 0))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(233 151 5), rgb(95 13 123))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(41 91 198), rgb(253 141 0))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                {/* <button
                  className={`preview-button`}
                >
                  <a href="https://www.mercymemorialkanpur.in" target="_blank" rel="noreferrer">
                    Live Preview
                  </a>
                </button> */}
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 11 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp12.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp12-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp12-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp12-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp12-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp12-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: NCSRD</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: Nirmala Convent School,
                    Rajkot
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(124 174 224), rgb(164 20 145))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(72 130 144), rgb(218 172 61))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(126 202 172), rgb(154 69 213))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://www.nirmalaconventschool.org/"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 12 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp13.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp13-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp13-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp13-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp13-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp13-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: MDAM</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: Notre Dame Academy, Munger
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(25 73 152), rgb(255 176 21))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(0 100 196), rgb(165 42 70))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(0 103 199), rgb(12 117 77))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender (Optional)</li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://www.ndmunger.com/"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 13 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp14.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp14-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp14-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp14-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp14-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp14-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: PCSDD</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: PCS Delhi
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(57 98 123), rgb(153 69 136))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(72 71 99), rgb(146 171 70))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(57 98 123), rgb(159 74 141))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender (Optional)</li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://www.pcsdelhi.in"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 14 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp15.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp15-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp15-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp15-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp15-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp15-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: SJSMH</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: St Joseph Mandi, Haryana
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(13 90 129), rgb(255 179 254))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(185 75 60), rgb(225 158 31))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(109 62 160), rgb(186 69 124))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://www.stjosephpilar.com"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 15 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp16.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp16-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp16-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp16-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp16-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp16-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: SBBS</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: St. Basil School, Basti
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(0 92 159), rgb(251 190 37))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(101 73 233), rgb(248 187 34))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(249 110 206), rgb(255, 166, 0))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets (Optional)</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://stbasilbasti.online/"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 16 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp17.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp17-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp17-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp17-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp17-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp17-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: SJSG</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: St. Joseph's School
                    Gorakhnath
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(102 178 201), rgb(255 225 113))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(52 93 122), rgb(245, 198, 42))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(140 216 236), rgb(245, 198, 42))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                {/* <button
                  className={`preview-button`}
                >
                  <a href="https://www.sjsgorakhnath.org" target="_blank" rel="noreferrer">
                    Live Preview
                  </a>
                </button> */}
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 17 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp18.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp18-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp18-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp18-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp18-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp18-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: SMCSST</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: St. Mary’s Convent Sr. Sec.
                    School, Tigaon
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(19 55 89), rgb(244 155 1))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(63 79 141), rgb(243 255 157))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(65 31 140), rgb(164 58 150))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets (Optional)</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://stmarysfbd.edu.in"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 18 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp19.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp19-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp19-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp19-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp19-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp19-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: SMCSU</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: St. Mary's Convent Sr. Sec.
                    School, Ujjain
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(30 49 151), rgb(195 131 34))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(233 113 173), rgb(65 112 198))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(50 77 210), rgb(202 140 41))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class (Optional)</li>
                        <li>Toppers Of XIIth Class (Optional)</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets (Optional)</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://www.stmarysujjain.online/"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 19 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp21.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp21-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp21-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp21-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp21-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp21-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: TPSB</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: Tagore Public School,
                    Ballabhgarh
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(253 154 28), rgb(51 51 51))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(51 51 51), rgb(44 64 146))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(207 56 161), rgb(51 51 51))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class (Optional)</li>
                        <li>Toppers Of XIIth Class (Optional)</li>
                        <li>Message of Management</li>
                        <li>Academic Calender (Optional)</li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://www.tagoreacademy.org.in"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 20 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div className="zoomIcon_list">
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp2.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp2-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp2-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp2-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp2-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp2-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: ABSB</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: Anand Bhavan School,
                    Barabanki
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(29 34 122), rgb(255 204 2))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background: "linear-gradient(45deg, #b74141, #f5c62a)",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(67 26 96), rgb(167 59 185))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>

                <button className={`preview-button`}>
                  <a
                    href="https://anandbhawanschool.com"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {popUp === 21 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp3.jpg"
                            className="img-fluid main-templete"
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp3-11.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp3-12.jpg"
                            className="img-fluid main-templete "
                            alt="Entab"
                          />
                        )}
                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp3-1.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp3-2.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp3-3.png"
                        className="img-fluid main-templete"
                        alt="Entab"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Templete Code: ACGS</h3>
                  <h4 className="mt-2">
                    Similar Design Used By School: Awadh College
                  </h4>
                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "maroon-color active-tab"
                          : "maroon-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(47 62 227), rgb(80 97 229))",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>
                    <div
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(62 168 156), rgb(255 145 49))",
                      }}
                      className={
                        colorTheme === "2"
                          ? "blue-color active-tab"
                          : "blue-color"
                      }
                      onClick={() => colorThemeSelect("2")}></div>
                    <div
                      className={
                        colorTheme === "3"
                          ? "green-color active-tab"
                          : "green-color"
                      }
                      style={{
                        background:
                          "linear-gradient(45deg, rgb(16 26 137), rgb(253 148 0))",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    This modern and interactive school website is designed to
                    provide students, parents, and staff with seamless access to
                    essential information. Built with React.js, it ensures a
                    fast, responsive, and engaging user experience. From
                    admission details to event updates, the website serves as a
                    central hub for all school-related activities.
                  </p>
                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Fast & Responsive </b>Optimized for speed and mobile
                        responsiveness.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Modern UI/UX </b>Clean and user-friendly design.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>SEO-Friendly </b>Built with SEO best practices for
                        better search rankings.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Cross-Browser Compatibility </b>Works seamlessly on
                        all major browsers.
                      </span>
                    </li>
                  </ul>
                  <h4> Performance & Optimization</h4>
                  <ul className="list-view">
                    <li>
                      <span>
                        <b>Lazy Loading </b>Loads components dynamically for
                        better performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Code Splitting </b>Improves loading speed by
                        splitting code into smaller bundles.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Optimized Images </b>Uses WebP and optimized images
                        for faster loading.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Server-Side Rendering </b>Faster page load and better
                        SEO with frameworks like React JS.
                      </span>
                    </li>
                  </ul>
                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {/* <li>Dark Mode Support – Toggle between light and dark themes.</li> */}
                    <li>
                      <span>
                        <b>Multi-Language Support </b>Available in multiple
                        languages.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Authentication System </b>Secure login, signup, and
                        user authentication with JWT or Firebase.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b> Admin Dashboard </b> Fully functional admin panel
                        for content and user management.
                      </span>
                    </li>
                  </ul>
                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &
                      efficiency to deliver optimal results.
                    </p>
                  </div>
                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        <li>Highlight Scrolling</li>
                        <li>Online Registration Blink Link</li>
                        <li>Latest News</li>
                        <li>Upcoming Events</li>
                        <li>Admission Enquiry </li>
                        <li>Photo Gallery </li>
                        <li>Toppers Of Xth Class</li>
                        <li>Toppers Of XIIth Class</li>
                        <li>Message of Management</li>
                        <li>Academic Calender </li>
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        <li>Header</li>
                        <li>Main Slider</li>
                        <li>Important Tabs</li>
                        <li>About Us</li>
                        <li>Useful Links and Important Links</li>
                        <li>Social Media widgets</li>
                        <li>Footer</li>
                      </ul>
                    </div>
                  </div>
                  <p className="mt-4">
                    <i class="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>
                {/*<button className={`preview-button`}>
                  <a href="https://www.littleflowerschoolgkp.com" target="_blank" rel="noreferrer"> Live Preview </a>
                </button>*/}
              </div>
            </div>
          </div>
        </div>
      )}
      {popUp === 22 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>

            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp24.jpg"
                            className="img-fluid main-templete"
                            alt="Template 24"
                          />
                        )}

                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp24-12.jpg"
                            className="img-fluid main-templete"
                            alt="Template 24"
                          />
                        )}

                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp24-13.jpg"
                            className="img-fluid main-templete"
                            alt="Template 24"
                          />
                        )}

                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>

                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp24-1.jpg"
                        className="img-fluid main-templete"
                        alt="Template View"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp24-2.jpg"
                        className="img-fluid main-templete"
                        alt="Template View"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp24-3.jpg"
                        className="img-fluid main-templete"
                        alt="Template View"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Template Code: </h3>
                  <h4 className="mt-2">Similar design used by school:</h4>

                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "Light_Blue+Dark_Blue active-tab"
                          : "Light_Blue+Dark_Blue"
                      }
                      style={{
                        background: "linear-gradient(45deg, #536DFE, #304FFE)",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>

                    <div
                      className={
                        colorTheme === "2"
                          ? "White+Blue active-tab"
                          : "White+Blue"
                      }
                      style={{
                        background: "linear-gradient(45deg, #FFFFFF, #00BFA5)",
                      }}
                      onClick={() => colorThemeSelect("2")}></div>

                    <div
                      className={
                        colorTheme === "3"
                          ? "White+Light_Blue active-tab"
                          : "White+Light_Blue"
                      }
                      style={{
                        background: "linear-gradient(45deg, #FFFFFF, #536DFE)",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    Fully responsive and optimized website template designed for
                    modern institutions. Built with React.js ensuring smooth
                    performance and seamless browsing experience across all
                    devices.
                  </p>

                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <b>Fast & Responsive</b> — Optimized performance.
                    </li>
                    <li>
                      <b>Modern UI/UX</b> — Clean and elegant layout.
                    </li>
                    <li>
                      <b>SEO-Friendly</b> — Search engine optimized.
                    </li>
                    <li>
                      <b>Cross-Browser Compatible</b> — Works on all devices.
                    </li>
                  </ul>

                  <p className="mt-4">
                    <i className="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {popUp === 23 && (
        <div className="popup">
          <div className="popup-content">
            <button className="close-popup" onClick={closePopup}>
              <i className="bi bi-x"></i>
            </button>

            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-6">
                  <Slider {...settings}>
                    <div>
                      <div
                        className="imgShow"
                        ref={imgContainerRef}
                        onClick={openFullscreen}
                        style={{
                          cursor: isFullscreen
                            ? "pointer"
                            : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                        }}>
                        {colorTheme === "1" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp25.jpg"
                            className="img-fluid main-templete"
                            alt="Template 24"
                          />
                        )}

                        {colorTheme === "2" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp25-12.jpg"
                            className="img-fluid main-templete"
                            alt="Template 24"
                          />
                        )}

                        {colorTheme === "3" && (
                          <img
                            src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp25-13.jpg"
                            className="img-fluid main-templete"
                            alt="Template 24"
                          />
                        )}

                        <button className="zoomImg" onClick={openFullscreen}>
                          <i class="bi bi-zoom-in"></i>
                        </button>
                      </div>
                    </div>

                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp25-1.jpg"
                        className="img-fluid main-templete"
                        alt="Template View"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp25-2.jpg"
                        className="img-fluid main-templete"
                        alt="Template View"
                      />
                    </div>
                    <div>
                      <img
                        src="https://webapi.entab.info/api/image/ENTAB/public/Images/temp25-3.jpg"
                        className="img-fluid main-templete"
                        alt="Template View"
                      />
                    </div>
                  </Slider>
                </div>

                <div className="col-xl-6 content-blk">
                  <h3>Template Code: SMNSB</h3>
                  <h4 className="mt-2">
                    Similar design used by school: SMNS Bokaro
                  </h4>

                  <div className="color-options">
                    <div
                      className={
                        colorTheme === "1"
                          ? "LEMON+BLUE active-tab"
                          : "LEMON+BLUE"
                      }
                      style={{
                        background: "linear-gradient(45deg, #FFEA00, #304FFE)",
                      }}
                      onClick={() => colorThemeSelect("1")}></div>

                    <div
                      className={
                        colorTheme === "2"
                          ? "PURPLE+BLUE active-tab"
                          : "PURPLE+BLUE"
                      }
                      style={{
                        background: "linear-gradient(45deg, #FFFFFF, #304FFE)",
                      }}
                      onClick={() => colorThemeSelect("2")}></div>

                    <div
                      className={
                        colorTheme === "3"
                          ? "TEAL+YELLOW active-tab"
                          : "TEAL+YELLOW"
                      }
                      style={{
                        background: "linear-gradient(45deg, #00BFA5, #536DFE)",
                      }}
                      onClick={() => colorThemeSelect("3")}></div>
                  </div>

                  <h4>Description</h4>
                  <p>
                    Fully responsive and optimized website template designed for
                    modern institutions. Built with React.js ensuring smooth
                    performance and seamless browsing experience across all
                    devices.
                  </p>

                  <h4>General Features</h4>
                  <ul className="list-view">
                    <li>
                      <b>Fast & Responsive</b> — Optimized performance.
                    </li>
                    <li>
                      <b>Modern UI/UX</b> — Clean and elegant layout.
                    </li>
                    <li>
                      <b>SEO-Friendly</b> — Search engine optimized.
                    </li>
                    <li>
                      <b>Cross-Browser Compatible</b> — Works on all devices.
                    </li>
                  </ul>

                  <p className="mt-4">
                    <i className="bi bi-clock-fill"></i> Required Time: 3 Days
                  </p>
                </div>
                <button className={`preview-button`}>
                  <a
                    href="https://www.smnsbokaro.in/"
                    target="_blank"
                    rel="noreferrer">
                    Live Preview
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
